import { render, staticRenderFns } from "./CodingList.vue?vue&type=template&id=5bf70fe5&"
var script = {}
import style0 from "./CodingList.vue?vue&type=style&index=0&id=5bf70fe5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports